export default __webpack_public_path__ + "static/media/WAS0450.34I-40966_-24925_0.1b8f4e68.jpg";